import AddIcon from '@mui/icons-material/Add';
import { Fab, Typography } from '@mui/material';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router';
import * as api from '../../api/app/localUserApi';
import { ApiError } from '../../components/core/ApiError/ApiError';
import { Loader } from '../../components/core/Loader/Loader';
import { PageContent } from '../../components/core/PageContent/PageContent';
import { PageHeader } from '../../components/core/PageHeader/PageHeader';
import { useAuth } from '../../contexts/authWindows';
import { useTranslation } from '../../contexts/translation';
import { UserRoles } from '../../types/core/auth.types';
import { LocalUserList } from './LocalUserList';

export function LocalUserPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const isReadOnly = user?.roles.includes(UserRoles.Admin) ? false : true;
  const {
    data: featureIsEnabled,
    isLoading,
    isError,
  } = useQuery<boolean>('featureIsEnabled', api.featureIsEnabled);

  const headerButtons = [
    <Fab
      key={0}
      color="primary"
      aria-label="add"
      size="medium"
      onClick={() => {
        navigate(`/localUser/create`);
      }}
    >
      <AddIcon />
    </Fab>,
  ];

  if (isError) return <ApiError />;
  if (isLoading || featureIsEnabled === undefined) return <Loader />;

  return (
    <>
      <PageHeader
        title={t('page.local-user.main-headline')}
        buttons={isReadOnly ? null : headerButtons}
        xs={6}
      />

      {featureIsEnabled && (
        <PageContent>
          <LocalUserList isReadOnly={isReadOnly} />
        </PageContent>
      )}
      {!featureIsEnabled && (
        <PageContent>
          <Typography>{t('page.local-user.function-disabled')}</Typography>
        </PageContent>
      )}
    </>
  );
}
